import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, Modal, Form, Switch, Popconfirm } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 }
}

type fetchParams = {
    store_id: string | undefined
    room_type_id: string | undefined
    room_number: string | undefined
    direction: number | undefined
    floor: string | undefined
    is_use: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

const initForm = {
    item_id: undefined,
    store_id: undefined,
    item_old_price: undefined,
    item_latest_price: undefined,
    order_level: undefined
}

// 朝向
const ways = [undefined, '朝南', '朝北', '朝东', '朝西', '东南', '东北', '西南', '西北']

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        room_type_id: undefined,
        room_number: undefined,
        direction: undefined,
        floor: undefined,
        is_use: undefined
    }

    const [form] = Form.useForm()

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [addVisible, setAddVisible] = useState<boolean>(false)
    const [activeID, setActiveID] = useState<string | undefined>(undefined)

    const [roomTypeList, setRoomTypeList] = useState<{ room_type_id: string, room_type_name: string }[]>([])

    const permission: string[] = useMemo(() => {
        // ['查询', '查看', '是否启用', '添加', '编辑', '删除']
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    useEffect(() => {
        // 查询房型
        baseAxiosNoInfo('/keeper/room/type/list').then((res: any) => {
            res && setRoomTypeList(res)
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/keeper/room/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const onFinish = (values: any) => {
        let url = activeID ? '/keeper/room/update' : '/keeper/room/add'

        if (activeID) {
            values.id = activeID
        }

        baseAxiosComplete.post(url, {
            room_id: activeID,
            ...values

        }).then(res => {
            if (res.status === 0) {
                setAddVisible(false)
                form.setFieldsValue(initForm)

                resetForm()
            }
        })
    }

    return (<div className="common-page">
        {/* 管家中心 -> 客房配置 -> 门店客房管理 */}
        <BreadCrumb position={['管家中心', '门店客房管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => {
                        handleChange(value, 'store_id')
                    }}
                        value={fetchOtherParams.store_id}
                    />
                </div>
                <Select style={{ marginRight: 8, marginBottom: 12, width: 150 }} allowClear onChange={(value: string) => { handleChange(value, 'room_type_id') }} placeholder="房型" value={fetchOtherParams.room_type_id} >
                    {roomTypeList.map((el: { room_type_id: string, room_type_name: string }) => <Option value={el.room_type_id}>{el.room_type_name}</Option>)}
                </Select>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <Select style={{ marginRight: 8, marginBottom: 12, width: 120 }} allowClear onChange={(value: number) => { handleChange(value, 'direction') }} placeholder="朝向" value={fetchOtherParams.direction} >
                    {ways.map((el: any, index: number) => el ? <Option value={index}>{el}</Option> : null)}
                </Select>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="楼层" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'floor') }} value={fetchOtherParams.floor} />
                <Select style={{ marginRight: 8, marginBottom: 12, width: 100 }} allowClear onChange={(value: number) => { handleChange(value, 'is_use') }} placeholder="是否启用" value={fetchOtherParams.is_use} >
                    <Option value={1}>是</Option>
                    <Option value={0}>否</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>

                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => {
                    form.setFieldsValue(initForm)
                    setActiveID(undefined)
                    setAddVisible(true)
                }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="房型" dataIndex="room_type_name" key="room_type_name" />
                <Column title="房间号" dataIndex="room_number" key="room_number" />
                <Column title="朝向" dataIndex="direction" key="direction" render={(v: number) => {
                    return <span>{ways[v]}</span>
                }} />
                <Column title="楼层" dataIndex="floor" key="floor" />
                <Column title="是否带窗" dataIndex="has_window" key="has_window" render={(v: number) => {
                    return v ? '是' : '否'
                }} />

                {permission.includes('是否启用') && <Column title="是否启用" render={(v: any) => {
                    return <Switch checked={v.is_use ? true : false} checkedChildren="开启" unCheckedChildren="关闭" onChange={(checked: boolean) => {
                        baseAxiosComplete.post('/keeper/room/open_or_close', {
                            room_id: v.id,
                            is_use: +checked
                        }).then(res => {
                            resetForm()
                        })
                    }} />
                }} />}

                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {permission.includes('编辑') && <Button type="primary" size="small" onClick={() => {
                                baseAxiosNoInfo('/keeper/room/detail', { params: { room_id: record.id } }).then((res: any) => {
                                    if (res) {
                                        form.setFieldsValue({
                                            "store_id": res.store_id,
                                            "room_type_id": res.room_type_id,
                                            "room_number": res.room_number,
                                            "direction": res.direction,
                                            "floor": res.floor,
                                            "has_window": res.has_window,
                                            "is_use": res.is_use

                                        })

                                        setActiveID(record.id)
                                        setAddVisible(true)
                                    }
                                })
                            }}>编辑</Button>}

                            {permission.includes('删除') && <Popconfirm
                                title="确定删除?"
                                onConfirm={() => {
                                    baseAxiosComplete.post('/keeper/room/delete', {
                                        room_id: record.id
                                    }).then(res => {
                                        if (res.status === 0) {
                                            resetForm()
                                        }
                                    })
                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button size="small">删除</Button>
                            </Popconfirm>}
                        </Space>
                    )}
                />
            </Table>
        </div>

        <Modal title={activeID ? "编辑客房" : "新增客房"} visible={addVisible} onCancel={() => { setAddVisible(false) }} footer={false} width="600px">
            <Form form={form} name="validate_other" {...formItemLayout} onFinish={onFinish}>
                <Form.Item label="门店" name="store_id" rules={[{ required: true, message: '必须选择所属门店' }]} >
                    <SelectStores />
                </Form.Item>

                <Form.Item label="房型" name="room_type_id" rules={[{ required: true, message: '必须选择房型' }]} >
                    <Select virtual={false} disabled={!!activeID} >
                        {roomTypeList.map((el: { room_type_id: string, room_type_name: string }) => <Option value={el.room_type_id}>{el.room_type_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item required label="房间号" name="room_number" rules={[{ required: true, message: '必须填写房间号' }]} >
                    <Input placeholder="输入房间号" />
                </Form.Item>

                <Form.Item label="朝向" name="direction" rules={[{ required: true, message: '必须选择朝向' }]} >
                    <Select virtual={false}  >
                        {ways.map((el: any, index: number) => el ? <Option value={index}>{el}</Option> : null)}
                    </Select>
                </Form.Item>

                <Form.Item required label="楼层" name="floor" rules={[{ required: true, message: '必须填写数字' }]} >
                    <Input type="number" placeholder="输入楼层" />
                </Form.Item>

                <Form.Item label="是否带窗" name="has_window" rules={[{ required: true, message: '必须选择是否带窗' }]} >
                    <Select virtual={false}  >
                        <Option value={1}>是</Option>
                        <Option value={0}>否</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="是否启用" name="is_use" rules={[{ required: true, message: '必须选择是否启用' }]} >
                    <Select virtual={false}  >
                        <Option value={1}>是</Option>
                        <Option value={0}>否</Option>
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}